import { css } from 'lit';
export default css `
  wui-compatible-network {
    margin-top: var(--wui-spacing-l);
  }
`;
//# sourceMappingURL=styles.js.map